var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypeRange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_3018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7521 0.999512H4.93256C2.76038 0.999512 0.999512 2.76044 0.999512 4.93262V21.7521C0.999512 23.9243 2.76038 25.6852 4.93256 25.6852H21.7521C23.9243 25.6852 25.6852 23.9243 25.6852 21.7521V4.93262C25.6852 2.76044 23.9243 0.999512 21.7521 0.999512Z",
    stroke: "black",
    strokeWidth: 1.99937,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81738 15.7583H21.8674",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8324 17.9937C18.067 17.9937 19.0678 16.9929 19.0678 15.7583C19.0678 14.5238 18.067 13.5229 16.8324 13.5229C15.5978 13.5229 14.5969 14.5238 14.5969 15.7583C14.5969 16.9929 15.5978 17.9937 16.8324 17.9937Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.00001,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81738 8.69141V10.1526",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8672 8.69141V10.1526",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22754 8.69141V10.1526",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6375 8.69141V10.1526",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0474 8.69141V10.1526",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4575 8.69141V10.1526",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_3018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.685,
    height: 26.685,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeRange);
export default __webpack_public_path__ + "static/media/icon_type_range.a9b343fcc0d40e15d22afba161eb6177.svg";
export { ForwardRef as ReactComponent };